import { useEffect, useState, type RefObject } from 'react'

/** Match SignatureCanvas bitmap size to its CSS box so strokes land where the pointer is. */
export const useSignatureCanvasSize = (containerRef: RefObject<HTMLElement | null>) => {
  const [size, setSize] = useState({ width: 0, height: 0 })

  useEffect(() => {
    const el = containerRef.current
    if (!el) return

    const update = () => {
      const { width, height } = el.getBoundingClientRect()
      const next = { width: Math.max(1, Math.floor(width)), height: Math.max(1, Math.floor(height)) }
      setSize(prev => (prev.width === next.width && prev.height === next.height ? prev : next))
    }

    update()
    const ro = new ResizeObserver(update)
    ro.observe(el)
    return () => ro.disconnect()
  }, [containerRef])

  return size
}
